import { render, staticRenderFns } from "./OrderSummarySale.vue?vue&type=template&id=00e8af85"
import script from "./OrderSummarySale.vue?vue&type=script&lang=js"
export * from "./OrderSummarySale.vue?vue&type=script&lang=js"
import style0 from "./OrderSummarySale.vue?vue&type=style&index=0&id=00e8af85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports